import { isBarcodeOpenAtom } from '@atoms/barcodeAtoms';
import Button from '@components/Button';
import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Row from '@components/Row';
import Switch from '@components/Switch';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { setBarcodeDialogOpen } from '@utils/nativeUtils';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const BarcodeModal: ActivityComponentType = () => {
    const { pop } = useFlow();
    const { t } = useTranslation('barcode');
    const [enabled, setEnabled] = useState<boolean>(false);
    const setBarcode = (value: boolean) => {
        window.localStorage.setItem('useBarcode', value.toString());
        setEnabled(value);
        setBarcodeDialogOpen(value);
    };
    useEffect(() => {
        setEnabled(window.localStorage.getItem('useBarcode') === 'true');
    }, []);
    const setIsBarcodeOpen = useSetAtom(isBarcodeOpenAtom);
    const close = () => {
        setIsBarcodeOpen(false);
        pop();
    };
    const { user } = useUser();
    return (
        <Modal borderRadius='12px'
            onOutsideClick={((e) => {
                e.preventDefault();
                e.stopPropagation();
            })}>
            <ModalContainer>
                <Column spacing={32} align='center'>
                    <Column spacing={12} align='center'>
                        <Text size='4xl' fontWeight='bold'>
                            {t('title')}
                        </Text>
                        <TooltipWrapper>
                            <Tooltip visibleKey='barcode'
                                backgroundColor={colors.primary}
                                top={-40}
                                left='unset'
                                right='unset'
                                bottom={12} >
                                {t('tooltip')}
                            </Tooltip>
                        </TooltipWrapper>
                        <Column spacing={6} align='center'>
                            <CustomBarcode value={user?.barcodeNo || ''}
                                height={60} />
                            <Text>{user?.barcodeNo.match(/.{1,4}/g)?.join(' ')}</Text>
                        </Column>
                        <Row spacing={8}
                            align='center'
                            justify='center'
                            fullWidth>
                            <Text color={colors.gray8}>
                                {t('shakeSetting')}
                            </Text>
                            <Switch checked={enabled}
                                setChecked={setBarcode} />
                        </Row>
                    </Column>
                    <Button fullWidth
                        onClick={close}>
                        {t('close')}
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

const TooltipWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    //height: 56px;
`;

export default BarcodeModal;
